// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1i9qm","requiredAsterisk":"Info_requiredAsterisk__2MP11"};